import React from 'react';
import { Paper, Box } from '@mui/material';
import SystemWidgetRenderer from './SystemWidgetRenderer';
import CustomChartWidget, { DashboardWidgetData } from './CustomChartWidget';

interface DashboardWidgetContentProps {
  widget: DashboardWidgetData;
  daysCount: number;
}

const DashboardWidgetContent: React.FC<DashboardWidgetContentProps> = ({ widget, daysCount }) => {
  return (
    <Paper
      sx={{
        height: '100%',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ flexGrow: 1, minHeight: 0, p: 1 }}>
        {widget.isSystem ? (
          <SystemWidgetRenderer systemKey={widget.systemKey || ''} daysCount={daysCount} />
        ) : (
          <CustomChartWidget widget={widget} daysCount={daysCount} />
        )}
      </Box>
    </Paper>
  );
};

export default DashboardWidgetContent;
